// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, import/no-extraneous-dependencies */
// FIXME: remove this disable directive and fix the ESLint error(s)

// @ts-expect-error: Flow to TS migration.
import fp from "lodash/fp"
import { createStore, applyMiddleware, compose, Store } from "redux"
// @ts-expect-error: Flow to TS migration.
import { createLogger } from "redux-logger"
import thunk from "redux-thunk"
// @ts-expect-error: Flow to TS migration.
import { initClient } from "splitster-redux"
import promiseMiddleware from "@kiwicom/frontend-common/services/middlewares/promise"
import crashReportMiddleware from "@kiwicom/frontend-common/services/middlewares/crashReport"
import hydrateInitialState from "@kiwicom/frontend-common/browser/hydrateInitialState"
import loggerColor from "@kiwicom/frontend-common/utils/loggerColor"

import trackMiddleware from "../services/middlewares/track"
import reducer from "../services"

const middleware = [thunk, promiseMiddleware, crashReportMiddleware, trackMiddleware]

const applied = fp.map(applyMiddleware, middleware)

// @ts-expect-error: Flow to TS migration.
if (__DEV__ && process.env.DEBUG_REDUX_LOGS) {
  const logger = createLogger({
    collapsed: true,
    colors: { title: loggerColor },
  })

  // FIXME: a method has been detected that possibly mutates the object, consider a more functional
  // approach (Ramda might help)

  applied.push(applyMiddleware(logger))
}

// https://github.com/zalmoxisus/redux-devtools-extension
// @ts-expect-error: Flow to TS migration.
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const store: Store<any, any, any> = composeEnhancers(...applied)(createStore)(
  reducer,
  // @ts-expect-error: Flow to TS migration.
  hydrateInitialState(window.__INITIAL_STATE__),
)

store.dispatch(
  initClient(
    // @ts-expect-error: Flow to TS migration.
    window.__INITIAL_STATE__.splitsterConfig,
    // @ts-expect-error: Flow to TS migration.
    window.__INITIAL_STATE__.splitsterUser,
    // @ts-expect-error: Flow to TS migration.
    window.__INITIAL_STATE__.options.userId,
  ),
)

export default store

// Redux HMR
// =========

// @ts-expect-error: Flow to TS migration.
if (module.hot) {
  // @ts-expect-error: Flow to TS migration.
  module.hot.accept("../services", () => {
    store.replaceReducer(reducer)
  })
}
